<template>
	<PageContainer>
		<AmeliproCard :card-title="cardTitle">
			<v-sheet
				class="overflow-y-auto cgu-content"
				max-height="50vh"
			>
				<v-list>
					<v-list-item>
						<v-list-item-content>
							<p class="mb-2">
								Le Service «<a
									href="https://pegase.ameli.fr"
									target="_blank"
								>https://pegase.ameli.fr</a>» est intégralement et exclusivement financé par la Cnam ; il
								n'accepte aucune forme de publicité ni ne reçoit de fonds
								publicitaire.
							</p>
							<p class="mb-2">
								Il permet la réception des gardes et astreintes effectuées par
								les professionnels de santé et la validation de ces dernières
								par les personnes concernées afin que l’Assurance Maladie puisse
								procéder à leur paiement.
							</p>
							<p class="mb-2">
								Ce service est gratuit et n'a aucune incidence sur les
								conditions de remboursements.
							</p>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Siège social</v-list-item-title>
							<v-list-item-subtitle>
								26-50, avenue du Professeur André Lemierre
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								75986 Paris Cedex 20
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								Tél. : +33 (0) 1 72 60 10 00
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								RCS : Cnam n° 180-035-024
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Directeur de la publication</v-list-item-title>
							<v-list-item-subtitle>
								Thomas Fatôme (directeur général)
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Crédit photographique</v-list-item-title>
							<v-list-item-subtitle> Cnam </v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>
								Hébergement et stockage des données
							</v-list-item-title>
							<v-list-item-subtitle>
								Nom : CTI STRASBOURG
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								Dénomination ou raison sociale : CTI STRASBOURG
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								Adresse : 650 Boulevard Sébastien BRANT 67405 ILLKIRCH cedex
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								Tel : 03 90 40 03 08
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-sheet>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { Meta, MetaInfo } from '@/decorators';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);

	@Component({})
	export default class LegalNotice extends MixinsDeclaration {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Mentions légales' as string
			};
		}

		cardTitle = 'Mentions légales « PEGASE »';
	}
</script>
<style scoped>
a {
  font-size: inherit;
}

.v-list-item__subtitle,
.v-list-item__title {
  font-size: 1em;
}
</style>
